'use client'

import { LeaderBoardAd } from '@/components/Ad/LeaderBoardAd'
import ContentHeader from '@/components/layout/ContentHeader'
import SidebarContainer, {
  EmptySidebarContainer
} from '@/components/layout/SidebarContainer'
import { ReactNode } from 'react'
import { rootPath } from 'shared/urlHelpers'

const GhostPage = ({
  page,
  extraClassName
}: {
  page: any // TODO : use proper type for Gost page
  extraClassName?: string
}): ReactNode => {
  return (
    <>
      <EmptySidebarContainer
        breadcrumbs={[
          {
            text: 'Home',
            path: rootPath()
          },
          {
            text: page.title
          }
        ]}
      >
        <LeaderBoardAd type={'header'} desktop mobile />
      </EmptySidebarContainer>

      <SidebarContainer>
        <div className="container-white">
          <ContentHeader title={page.title} />
          <div
            className={`prose ${extraClassName}`}
            dangerouslySetInnerHTML={{ __html: page.html }}
          ></div>
        </div>
      </SidebarContainer>

      <EmptySidebarContainer>
        <LeaderBoardAd type={'footer'} mobile desktop />
      </EmptySidebarContainer>

      <LeaderBoardAd type={'sticky'} mobile sticky />
    </>
  )
}

export default GhostPage
